import React, { useEffect, useState } from "react";
import MonthlyCommonDashboard from "../MonthlyCommonDashboard/MonthlyCommonDashboard";
import { GetLoanPaidInExcessVSEligibilityReport } from "../../../../Helpers/APIEndPoints/EndPoints";

const LoanPaidInExcess = () => {
  return (
    <>
      <MonthlyCommonDashboard
        PageName="LoanPaidInExcess"
        ExportToExcelUrl={GetLoanPaidInExcessVSEligibilityReport}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default LoanPaidInExcess;
